// @ts-nocheck
import { Component } from "@theme/component";
/**
 *
 * @typedef {object} Refs
 * @property {HTMLDivElement} locatorContainer - The container element for the locator widget.
 * @extends {Component<Refs>}
 */
class DoctorLocator extends Component {
  requiredRefs = ["locatorContainer"];

  get country() {
    return this.dataset.country;
  }
  get countryLowercase() {
    return this.dataset.country.toLowerCase();
  }
  get language() {
    return this.dataset.language;
  }
  get labels() {
    try {
      return JSON.parse(this.dataset.labels || "{}");
    } catch {
      return {};
    }
  }
  get tenantKey() {
    return `nuance_${this.countryLowercase}`;
  }

  get bookAppointmentUrl() {
    return this.dataset.bookAppointmentUrl;
  }

  get customerId() {
    return this.dataset.customerId;
  }

  connectedCallback() {
    super.connectedCallback();
    this.initDoctorLocator();
  }

  disconnectedCallback() {
    super.disconnectedCallback();
  }
  initDoctorLocator() {
    //we can use Shopify.locale but it's not documented, so we pass object with liquid

    const containerId = "#" + this.refs.locatorContainer.id;

    const config = {
      selector: containerId,
      tenantKey: this.tenantKey,
      locale: this.language + "-" + this.countryLowercase,
      skipRedirect: true,
      onTabliteAppointmentClick: (/** @type {object} */ data) => {
        this.redirectToTablite(data);
      },
      labels: this.labels,
      routerMode: "browser", //keep params in url
    };

    if (this.customerId) {
      config.options = { enable_favorites: true };
      config.userId = this.customerId;
    }

    //console.log("config:", config);

    const locatorApp = new locator.LocatorWidget(config);
    locatorApp.init();
  }

  /**
   * @param {object} data
   */
  redirectToTablite(data) {
    const storeNumber = data.storeNumber || "";
    const storeBrandName = data.storeBrandName || "";

    const url = new URL(this.bookAppointmentUrl, window.location.origin);
    url.searchParams.set("storeNumber", storeNumber);
    url.searchParams.set("storeBrandName", storeBrandName);

    window.location.href = url.toString();
  }
}

if (!customElements.get("doctor-locator")) {
  customElements.define("doctor-locator", DoctorLocator);
}
